import React from "react";

import { FormattedMessage, useIntl } from "react-intl";

import { CwsA } from "cms-web-styleguide/dist/components/CwsA/CwsA";
import { CwsAccordion } from "cms-web-styleguide/dist/components/CwsAccordion/CwsAccordion";
import { CwsAccordionItem } from "cms-web-styleguide/dist/components/CwsAccordion/CwsAccordionItem/CwsAccordionItem";
import { CwsAccordionItemBody } from "cms-web-styleguide/dist/components/CwsAccordion/CwsAccordionItem/CwsAccordionItemBody/CwsAccordionItemBody";
import { CwsAccordionItemHeader } from "cms-web-styleguide/dist/components/CwsAccordion/CwsAccordionItem/CwsAccordionItemHeader/CwsAccordionItemHeader";
import { CwsBr } from "cms-web-styleguide/dist/components/CwsTypography/CwsBr/CwsBr";
import { CwsDivider } from "cms-web-styleguide/dist/components/CwsDivider/CwsDivider";
import { CwsH3 } from "cms-web-styleguide/dist/components/CwsTypography/CwsH3/CwsH3";
import { CwsH4 } from "cms-web-styleguide/dist/components/CwsTypography/CwsH4/CwsH4";
import { CwsList } from "cms-web-styleguide/dist/components/CwsList/CwsList";
import { CwsListItem } from "cms-web-styleguide/dist/components/CwsList/CwsListItem/CwsListItem";
import { CwsP } from "cms-web-styleguide/dist/components/CwsTypography/CwsP/CwsP";

const PrivacyPolicyTab = () => {
  const intl = useIntl();

  return (
    <>
      <CwsH3>
        <FormattedMessage id="popup.tab.label.privacy.policy" />
      </CwsH3>
      <CwsP size="small">
        <FormattedMessage
          id="popup.privacy.policy.description.1"
          values={{
            privacyPolicy: (
              <strong>
                <FormattedMessage id="popup.tab.label.privacy.policy" />
              </strong>
            ),
            tallink: (
              <strong>
                <FormattedMessage id="tallink.label" />
              </strong>
            ),
          }}
        />
      </CwsP>
      <CwsP size="small">
        <FormattedMessage
          id="popup.privacy.policy.description.2"
          values={{
            link: (
              <CwsA
                inline
                href={intl.formatMessage({
                  id: "popup.privacy.policy.description.2.link",
                })}
                target="_blank"
                size="small"
              >
                {intl.formatMessage({
                  id: "popup.privacy.policy.description.2.link",
                })}
              </CwsA>
            ),
          }}
        />
        .
      </CwsP>
      <CwsP size="small">
        <FormattedMessage id="popup.privacy.policy.description.3" />
      </CwsP>
      <CwsP size="small">
        <FormattedMessage id="popup.privacy.policy.description.4" />
      </CwsP>
      <CwsP size="small">
        <FormattedMessage id="popup.privacy.policy.description.5" />
      </CwsP>
      <CwsP size="small">
        <FormattedMessage id="popup.privacy.policy.description.6" />
      </CwsP>

      <CwsDivider className="cws-mt-xs" />

      <CwsAccordion>
        <CwsAccordionItem id="privacy-policy-1">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.1.label" />}
          />
          <CwsAccordionItemBody>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.1.description.1.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.1.description.1"
                values={{
                  separator: <CwsBr />,
                  link: (
                    <CwsA inline href="mailto:info@tallink.ee" size="small">
                      info@tallink.ee
                    </CwsA>
                  ),
                }}
              />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.1.description.2.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.1.description.2" />
            </CwsP>
            <CwsList size="small">
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.1.description.2.list.1" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.1.description.2.list.2" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.1.description.2.list.3" />
              </CwsListItem>
            </CwsList>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.1.description.3.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.1.description.3.1"
                values={{
                  DPO: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.1.description.3.1.dpo" />
                    </strong>
                  ),
                }}
              />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.1.description.3.2" />
            </CwsP>
            <CwsP hideSpacing size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.1.description.3.3"
                values={{
                  separator: <CwsBr />,
                  link: (
                    <CwsA inline href="mailto:dpo@tallink.com" size="small">
                      dpo@tallink.com
                    </CwsA>
                  ),
                }}
              />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="privacy-policy-2">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.2.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.2.sub-description" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.1.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.1." />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.2.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.2" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.3.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.3" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.4.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.2.description.4"
                values={{
                  link: (
                    <CwsA inline href="mailto:privacy@tallink.com" size="small">
                      privacy@tallink.com
                    </CwsA>
                  ),
                }}
              />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.5.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.5" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.6.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.6.1" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.6.2" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.7.label" />
            </CwsH4>
            <CwsP hideSpacing size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.2.description.7" />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="privacy-policy-3">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.3.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.3.description.1" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.3.description.2" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.3.description.3" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.3.description.4"
                values={{
                  link: (
                    <CwsA inline href="mailto:privacy@tallink.com" size="small">
                      privacy@tallink.com
                    </CwsA>
                  ),
                  title: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.3.description.4.title" />
                    </strong>
                  ),
                }}
              />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.3.description.5"
                values={{
                  title: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.3.description.5.title" />
                    </strong>
                  ),
                }}
              />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.3.description.6"
                values={{
                  title: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.3.description.6.title" />
                    </strong>
                  ),
                  link: (
                    <CwsA inline href="mailto:privacy@tallink.com" size="small">
                      privacy@tallink.com
                    </CwsA>
                  ),
                }}
              />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.3.description.7"
                values={{
                  title: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.3.description.7.title" />
                    </strong>
                  ),
                }}
              />
            </CwsP>
            <CwsList size="small">
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.3.description.7.list.1" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.3.description.7.list.2" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.3.description.7.list.3" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.3.description.7.list.4" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.3.description.7.list.5" />
              </CwsListItem>
            </CwsList>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.3.description.8" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.3.description.9"
                values={{
                  title: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.3.description.9.title" />
                    </strong>
                  ),
                }}
              />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.3.description.10"
                values={{
                  title: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.3.description.10.title" />
                    </strong>
                  ),
                }}
              />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.3.description.11"
                values={{
                  title: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.3.description.11.title" />
                    </strong>
                  ),
                }}
              />
            </CwsP>
            <CwsList size="small">
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.3.description.11.list.1" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.3.description.11.list.2" />
              </CwsListItem>
            </CwsList>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.3.description.12"
                values={{
                  title: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.3.description.12.title" />
                    </strong>
                  ),
                }}
              />
            </CwsP>
            <CwsP hideSpacing size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.3.description.13"
                values={{
                  title: (
                    <strong>
                      <FormattedMessage id="popup.privacy.policy.accordion.3.description.13.title" />
                    </strong>
                  ),
                }}
              />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="privacy-policy-4">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.4.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.4.description" />
            </CwsP>
            <CwsList size="small">
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.1" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.2" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.3" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.4" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.5" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.6" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.7" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.8" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.9" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.4.description.list.10" />
              </CwsListItem>
            </CwsList>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="privacy-policy-5">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.5.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.5.description" />
            </CwsP>
            <CwsList size="small">
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.5.description.list.1" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.5.description.list.2" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.5.description.list.3" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.5.description.list.4" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.5.description.list.5" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.5.description.list.6" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.5.description.list.7" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.5.description.list.8" />
              </CwsListItem>
              <CwsListItem>
                <FormattedMessage id="popup.privacy.policy.accordion.5.description.list.9" />
              </CwsListItem>
            </CwsList>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="privacy-policy-6">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.6.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.6.sub-description" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.1.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.1.1" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.1.2" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.2.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.2" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.3.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.3" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.4.label" />
            </CwsH4>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.4" />
            </CwsP>
            <CwsH4>
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.5.label" />
            </CwsH4>
            <CwsP hideSpacing size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.6.description.5" />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="privacy-policy-7">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.7.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.7.description.1" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.7.description.2" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.7.description.3" />
            </CwsP>
            <CwsP hideSpacing size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.7.description.4" />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="privacy-policy-8">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.8.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.8.description.1" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.8.description.2" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.8.description.3" />
            </CwsP>
            <CwsP size="small">
              <FormattedMessage
                id="popup.privacy.policy.accordion.8.description.4"
                values={{
                  linkPrivacyPolicyGoogle: (
                    <CwsA
                      inline
                      href={intl.formatMessage({
                        id: "privacy.policy.google.link",
                      })}
                      size="small"
                      target="_blank"
                    >
                      {intl.formatMessage({
                        id: "privacy.policy.google.name",
                      })}
                    </CwsA>
                  ),
                  linkPrivacyPolicyLinkedIn: (
                    <CwsA
                      inline
                      href={intl.formatMessage({
                        id: "privacy.policy.linkedin.link",
                      })}
                      size="small"
                      target="_blank"
                    >
                      {intl.formatMessage({
                        id: "privacy.policy.linkedin.name",
                      })}
                    </CwsA>
                  ),
                  linkPrivacyPolicyMeta: (
                    <CwsA
                      inline
                      href={intl.formatMessage({
                        id: "privacy.policy.meta.link",
                      })}
                      size="small"
                      target="_blank"
                    >
                      {intl.formatMessage({
                        id: "privacy.policy.meta.name",
                      })}
                    </CwsA>
                  ),
                }}
              />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="privacy-policy-9">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.9.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.9.description.1" />
            </CwsP>
            <CwsP hideSpacing size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.9.description.2" />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
        <CwsAccordionItem id="privacy-policy-10">
          <CwsAccordionItemHeader
            iconMode="dom"
            label={<FormattedMessage id="popup.privacy.policy.accordion.10.label" />}
          />
          <CwsAccordionItemBody>
            <CwsP hideSpacing size="small">
              <FormattedMessage id="popup.privacy.policy.accordion.10.description" />
            </CwsP>
          </CwsAccordionItemBody>
        </CwsAccordionItem>
      </CwsAccordion>
      <CwsDivider />
    </>
  );
};

export { PrivacyPolicyTab };
